import { html } from "lit";

export const verticleCurve = () => html`
  <svg
    width="126"
    height="200"
    viewBox="0 0 126 200"
    class="twf-hidden md:twf-block twf-h-full twf-absolute twf-top-0 twf-left-[110px] twf-rounded-md"
    preserveAspectRatio="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M67.8959 236C97.0254 220.197 126 186.097 126 136.094C126 29.0246 9.92429 43.186 9.92429 -63.8614C9.92429 -113.875 37.6498 -145.436 67.9953 -164H0.5L0.5 236L67.8959 236Z" fill="#F8F2FF" />
  </svg>
`;
